<span class="search-input-container">
    <img [alt]="getString('searchPlaceholder')" class="magnifier-icon" src="./assets/images/flyout_lupe_white.png">
    <input type="text" class="search-input" [placeholder]="getPlaceholderText()" (keyup)="onKeyUp($event)" [(ngModel)]="query" (focus)="onFocus()">
    <span *ngIf="inputValue" class="close-icon" (click)="resetSearch()">✕</span>
</span>

<app-search-suggestions *ngIf="showSuggestions && activateSuggestions" class="suggestions-component" [suggestions]="suggestions" [inputValue]="inputValue" (onSearchClicked)="searchClick()"></app-search-suggestions>